import { getDomain } from "@/utils/route-utils";
import { Button } from "@stackje/shared-components/ui/button";
import { Input } from "@stackje/shared-components/ui/input";
import { Navigate } from "@tanstack/react-router";
import { useChooseSubdomain } from "@/hooks/useChooseSubdomain";

export function ChooseSubdomainPage() {
  const {
    linkName,
    setLinkName,
    isSubmitting,
    actionData,
    submissionSuccess,
    handleSubmit,
    newSiteId,
  } = useChooseSubdomain();

  if (submissionSuccess && newSiteId) {
    return <Navigate to="/setup-site-theme" replace />;
  }

  return (
    <form method="post" onSubmit={handleSubmit} className="">
      <div className="min-h-[90lvh] bg-white flex flex-col justify-between p-6 pb-safe pt-safe pl-safe pr-safe">
        <div className="space-y-4 max-w-md mx-auto w-full pt-12">
          <h1 className="text-4xl font-bold leading-tight">
            Create the link to your website
          </h1>
          <p className="text-md text-gray-600">
            We recommend putting your name or your business name. Something easy
            to remember.
          </p>
          <div className="flex items-stretch mt-12">
            <div className="flex-grow border rounded-l-md overflow-hidden">
              <Input
                type="text"
                name="subdomain"
                aria-label="Your subdomain"
                value={linkName}
                onChange={(e) => setLinkName(e.target.value.toLowerCase())}
                className="h-full px-4 rounded-l-md border-none"
                autoFocus
                required
              />
            </div>
            <div className="text-gray-600 bg-gray-100 px-4 rounded-r-md border border-l-0 flex items-center h-12">
              .{getDomain()}
            </div>
          </div>
        </div>
        <div className="space-y-6 max-w-md mx-auto w-full mb-6">
          {actionData?.error && (
            <p className="text-red-500 text-sm">{actionData.error}</p>
          )}
          <div className="flex items-start space-x-4 text-sm text-gray-600 bg-gray-50 p-4 rounded-lg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="text-primary flex-shrink-0 mt-1"
            >
              <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" />
              <path d="m9 12 2 2 4-4" />
            </svg>
            <p>
              Tip: You can use a custom domain when you upgrade to Pro later. 
            </p>
          </div>
          <Button
            type="submit"
            className="w-full text-lg py-6 rounded-md"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Creating..." : "Create Link"}
          </Button>
        </div>
      </div>
    </form>
  );
}
